

const ehliyetOptions = [
    {
        id:1,
        text:"B: Otomobil-Kamyonet",
        value: "B"
    },
    {
        id:2,
        text:"BE: Römorklu Otomobil-Kamyonet",
        value: "BE"
    },
    {
        id:3,
        text:"C1: 7,5 Tona Kadar Kamyon-Çekici",
        value: "C1"
    },
    {
        id:4,
        text:"C: Kamyon-Çekici",
        value: "C"
    },
    {
        id:5,
        text:"CE: Römorklu Kamyon-Çekici",
        value: "CE"
    },
    {
        id:6,
        text:"D: Minibüs-Otobüs",
        value: "D"
    },
    {
        id:7,
        text:"DE: Römorklu Minibüs-Otobüs",
        value: "DE"
    },
    {
        id:8,
        text:"G: İş Makinesi",
        value: "GE"
    }
]

export default ehliyetOptions